// Vigilant Entities — Brand Book v1.0 constants

// Build / release identifier rendered next to the wordmark.
// Update both fields on every functional release.
export const BUILD = {
  version: 'v1.6.4',
  date: '2026.02.10',
  codename: 'Custom Fields',
};

export const BRAND = {
  name: 'Vigilant Entities',
  shortName: 'VE',
  tagline: 'Vigilance. Governance. Growth.',
  taglineLong: 'Where Capital Meets Stewardship.',
  // The AI-generated marketing imagery (kept neutral / executive)
  heroImage: 'https://static.prod-images.emergentagent.com/jobs/7caeeb62-4a4a-4a6a-864b-d6bf51231f27/images/9623b32071eaf1c7d4737a1a6a60d973d460317b93b2227b968d1d3e76082a25.png',
  abstractBg: 'https://static.prod-images.emergentagent.com/jobs/7caeeb62-4a4a-4a6a-864b-d6bf51231f27/images/d23e0a541933250695806872ec7e5e6000316bc648b7684430269a145ec6f48b.png',
  boardImg1: 'https://images.unsplash.com/photo-1739298061707-cefee19941b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzB8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBib2FyZCUyMG1lZXRpbmd8ZW58MHx8fHwxNzgwMjU1ODMxfDA&ixlib=rb-4.1.0&q=85',
  boardImg2: 'https://images.pexels.com/photos/6949865/pexels-photo-6949865.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  contactEmail: 'hello@vigilantentities.com',
  city: 'Doha · Dubai · London · New York',
};

export const COLORS = {
  gold: '#8B3FC5',
  goldBright: '#AE52EA',
  goldDeep: '#5E1F8B',
  silver: '#C0C0C0',
  black: '#0A0A0A',
  white: '#FFFFFF',
};

export const ROLES = [
  { id: 'holding_admin', label: 'Holding Admin' },
  { id: 'chairman', label: 'Chairman' },
  { id: 'ceo', label: 'CEO' },
  { id: 'cfo', label: 'CFO' },
  { id: 'legal', label: 'Legal Counsel' },
  { id: 'investor', label: 'Investor' },
  { id: 'founder', label: 'Founder' },
  { id: 'startup_member', label: 'Startup Member' },
  { id: 'guest', label: 'Guest' },
];

export const PARTNERSHIP_TYPES = [
  { id: 'mou_30', label: 'MOU — 30% (Gold Standard)', goldStandard: true },
  { id: 'jv', label: 'Joint Venture' },
  { id: 'equity', label: 'Pure Equity' },
  { id: 'knowledge_sharing', label: 'Knowledge Sharing' },
  { id: 'acquisition', label: 'Acquisition' },
];

export const TRUSTED_LOGOS = [
  'QATAR FOUNDATION', 'MASTERCARD', 'BARCLAYS', 'AEGON', 'BNY MELLON', 'AFTERPAY', 'EMIRATES', 'ARAMCO',
];

export const PRICING_TIERS = [
  {
    name: 'Essentials',
    price: 'From $25,000',
    period: '/year',
    description: 'Core board management, entity records and policy basics for emerging organisations.',
    features: [
      'Board portal for up to 25 directors',
      'Entity & subsidiary register',
      'Policy library + e-sign',
      'Basic risk register',
      'Email + chat support',
    ],
    cta: 'Request Pricing',
    accent: false,
  },
  {
    name: 'Advanced',
    price: 'From $75,000',
    period: '/year',
    description: 'Connected GRC across governance, risk, and audit with AI-assisted workflows.',
    features: [
      'Unlimited directors + committees',
      'Enterprise Risk + IT Risk Management',
      'Third-Party Risk (3rdRisk) + Sanctions',
      'Audit Management + SOX Controls',
      'AI Pitch Vetting + Investor CRM',
      'Dedicated success manager',
    ],
    cta: 'Talk to Sales',
    accent: true,
  },
  {
    name: 'Sovereign',
    price: 'Custom',
    period: '',
    description: 'White-glove deployment for sovereigns, holdings, and global incubators.',
    features: [
      'Everything in Advanced',
      'Dedicated tenant + data residency',
      'White-label + multi-language',
      'SLAs incl. 24/7 priority + SOC2',
      'Bespoke AI agents & workflows',
      'On-site enablement',
    ],
    cta: 'Request Sovereign',
    accent: false,
  },
];
